var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.509 16.783a10.405 10.405 0 0 0 1.966-6.109C26.475 4.885 21.784.2 16.001.2S5.527 4.886 5.527 10.674c0 2.269.726 4.371 1.949 6.091 3.829 5.891 8.509 15.103 8.509 15.103l.006-.046v.046c0-.006 4.691-9.194 8.52-15.086zM16 6.646c2.223 0 4.029 1.806 4.029 4.029S18.223 14.704 16 14.704s-4.029-1.806-4.029-4.029S13.777 6.646 16 6.646z"
  })));
};
export default SvgLocation;